import { Text } from '@react-pdf/renderer';

import { GalenDataUser } from 'src/models/GalenData/User.model';
import { handleNSI18Next } from 'src/models/Language.model';

import { cls } from 'src/utils/reactPdfStyles';

interface VersionSectionProps {
  currentUser: GalenDataUser;
  formattedTimestamp: string;
}

const VersionSection = ({
  currentUser,
  formattedTimestamp,
}: VersionSectionProps) => {
  const { handleReportT } = handleNSI18Next();

  const practiceName = currentUser.currentRole?.practice?.name;
  return (
    <Text style={cls('p mb-0')}>
      {handleReportT(`resultSection.clinicianEntryText`, {
        practiceName: practiceName ?? '',
        timestamp: formattedTimestamp,
      })}
    </Text>
  );
};

export default VersionSection;
